/** When your routing table is too long, you can split it into small modules**/
/* Layout */
import Layout from '@/layout'

/* Router Modules */
const storeAccountRouters = {
  path: '/storeAccount',
  component: Layout,
  name: 'storeAccount',
  meta: {
    title: '门店账号管理',
    icon: 'el-icon-files'
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/shop/list'),
      name: 'storeAccountList',
      meta: { title: '门店账号' }
    }
  ]
}

export default storeAccountRouters
